<template>
  <div
    v-if="errorMessage"
    class="error-message-for-incorrect-input"
    :class="`--${deviceType}`"
  >
    <div class="error-message-for-incorrect-input__icon">
      <Icon
        name="alert"
        color="#CC0621"
        :height="deviceType === 'pc' ? 24 : 20"
        :width="deviceType === 'pc' ? 24 : 20"
      />
    </div>
    <p class="error-message-for-incorrect-input__text">{{ errorMessage }}</p>
  </div>
</template>

<script>
// 「views/search/BS_SCH_03_001」内のみで使用する、
// エラーメッセージを表示するコンポーネント
export default {
  props: {
    // 表示されるエラーメッセージ
    errorMessage: {
      type: String,
      required: false,
      default: ''
    },
    // pcとspでスタイルやアイコンサイズが違うので
    // class名に使用し、出し分ける
    deviceType: {
      type: String,
      required: false,
      default: 'pc',
      validator: (value) => {
        return ['pc', 'sp'].includes(value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin sp {
  @media screen and (max-width: 639px) {
    @content;
  }
};

$error: #cc0621;

.error-message-for-incorrect-input {
  align-items: center;
  display: flex;
  line-height: normal;

  &.--pc {
    margin-bottom: 1rem;
    @include sp {
      display: none;
    }
  }

  &.--sp {
    padding-bottom: .5rem;
  }

  &__icon {
    flex-shrink: 0;
    height: 1.5rem;
    margin-right: .25rem;
    width: 1.5rem;

    @include sp {
      height: 1.25rem;
      width: 1.25rem;
    }
  }

  &__text {
    color: $error;
    font-size: .875rem;
    font-weight: bold;
    line-height: 1.2;

    @include sp {
      font-size: .75rem;
    }
  }
}
</style>